(function () {
  'use strict';


  /* =========================================================
     HELPERS
     ========================================================= */

  function cleanText(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }


  function getProduct(card) {

    const raw =
      card.getAttribute('data-json-product');

    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  }


  function isSoldOut(card) {

    const product =
      getProduct(card);

    /*
     * Recently Viewed has no embedded JSON.
     * finches-recent-cart.js handles its availability.
     */
    if (!product) {
      return false;
    }


    if (product.available === false) {
      return true;
    }


    if (Array.isArray(product.variants)) {

      return !product.variants.some(
        function (variant) {
          return variant.available;
        }
      );
    }


    return false;
  }


  /* =========================================================
     FIND SECTIONS
     ========================================================= */

  function findHeading(text) {

    const wanted =
      cleanText(text);


    const candidates =
      Array.from(
        document.querySelectorAll(
          'h1,h2,h3,h4,h5,h6,' +
          '.title,.title_block,.section-title,.heading,' +
          '[class*="title"],[class*="heading"]'
        )
      );


    return candidates.find(
      function (element) {

        return (
          cleanText(element.textContent) ===
          wanted
        );

      }
    ) || null;
  }


  function findSection(heading) {

    if (!heading) {
      return null;
    }


    let current =
      heading;


    for (
      let i = 0;
      i < 12 && current;
      i++
    ) {

      if (
        current.querySelectorAll &&
        current.querySelectorAll(
          '.item-product.h_bd'
        ).length
      ) {
        return current;
      }


      current =
        current.parentElement;
    }


    return null;
  }


  function tagSections() {

    const related =
      findSection(
        findHeading('RELATED PRODUCT')
      );


    if (related) {

      related.classList.add(
        'finches-secondary-products',
        'finches-related-products'
      );
    }


    const recent =
      findSection(
        findHeading(
          'RECENTLY VIEWED PRODUCTS'
        )
      );


    if (recent) {

      recent.classList.add(
        'finches-secondary-products',
        'finches-recent-products'
      );
    }
  }


  /* =========================================================
     FIND REAL VINOVA ADD TO CART BUTTON
     ========================================================= */

  function getNativeAction(card) {

    /*
     * Best option:
     * Vinova's direct card form.
     */
    let button =
      card.querySelector(
        'form.one-option-color ' +
        '.add-to-cart-btn'
      );


    if (
      button &&
      !button.disabled
    ) {

      return {
        button: button,
        form: button.closest('form')
      };
    }


    /*
     * Find normal Add To Cart button,
     * excluding Quick Add / variants popup.
     */
    const buttons =
      Array.from(
        card.querySelectorAll(
          '.add-to-cart-btn,' +
          'button[type="submit"]'
        )
      );


    button =
      buttons.find(
        function (candidate) {

          if (
            candidate.closest(
              'form.variants'
            )
          ) {
            return false;
          }


          if (
            candidate.disabled ||
            candidate.getAttribute(
              'aria-disabled'
            ) === 'true'
          ) {
            return false;
          }


          const text =
            cleanText(
              candidate.textContent
            );


          return (
            text !== 'SOLD OUT'
          );
        }
      );


    if (!button) {
      return null;
    }


    return {
      button: button,
      form: button.closest('form')
    };
  }


  /* =========================================================
     TRIGGER VINOVA'S OWN JQUERY HANDLER
     ========================================================= */

  function triggerVinovaAdd(button) {

    if (!button) {
      return false;
    }


    /*
     * Your debug trace confirmed the theme's native
     * flow is jQuery AJAX.
     *
     * Triggering through jQuery ensures Vinova gets
     * the same click it expects from its original button.
     */
    if (
      window.jQuery &&
      typeof window.jQuery === 'function'
    ) {

      window.jQuery(button)
        .trigger('click');

      return true;
    }


    /*
     * Fallback.
     */
    button.dispatchEvent(
      new MouseEvent(
        'click',
        {
          bubbles: true,
          cancelable: true,
          view: window
        }
      )
    );


    return true;
  }


  /* =========================================================
     RELATED PRODUCT BUTTON
     ========================================================= */

  function setupCard(card) {

    let button =
      card.querySelector(
        ':scope > .finches-secondary-add'
      );


    if (!button) {

      button =
        document.createElement('button');

      button.type =
        'button';

      button.className =
        'finches-secondary-add';

      card.appendChild(button);
    }


    /*
     * Recently Viewed is handled entirely by
     * finches-recent-cart.js.
     */
    if (
      card.closest(
        '.finches-recent-products'
      )
    ) {

      if (
        !button.classList.contains(
          'is-sold-out'
        )
      ) {

        button.textContent =
          'ADD TO BAG';

        button.disabled =
          false;
      }


      return;
    }


    /*
     * RELATED PRODUCTS
     */
    if (isSoldOut(card)) {

      button.textContent =
        'SOLD OUT';

      button.disabled =
        true;

      button.classList.add(
        'is-sold-out'
      );

      return;
    }


    button.textContent =
      'ADD TO BAG';

    button.disabled =
      false;

    button.classList.remove(
      'is-sold-out'
    );


    /*
     * Don't bind multiple times.
     */
    if (
      button.dataset.finchesRelatedBound ===
      '1'
    ) {
      return;
    }


    button.dataset.finchesRelatedBound =
      '1';


    button.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();


        if (
          button.dataset.finchesBusy ===
          '1'
        ) {
          return;
        }


        const native =
          getNativeAction(card);


        if (
          !native ||
          !native.button
        ) {

          console.warn(
            'Finches: native Related Product cart button not found',
            card
          );

          return;
        }


        button.dataset.finchesBusy =
          '1';

        button.textContent =
          'ADDING...';


        /*
         * IMPORTANT:
         *
         * Do NOT fetch /cart/add.js here.
         *
         * Let Vinova itself perform:
         *
         * POST /cart/add.js
         * GET /cart?view=json
         * GET /cart/?view=upsell
         * GET /cart.js
         *
         * and open its own popup.
         */
        triggerVinovaAdd(
          native.button
        );


        setTimeout(
          function () {

            button.textContent =
              'ADD TO BAG';

            button.dataset.finchesBusy =
              '0';

          },
          1800
        );
      }
    );
  }


  function setupCards() {

    document
      .querySelectorAll(
        '.finches-secondary-products ' +
        '.item-product.h_bd'
      )
      .forEach(setupCard);
  }


  /* =========================================================
     INIT
     ========================================================= */

  function run() {

    tagSections();
    setupCards();
  }


  function init() {

    [
      0,
      300,
      800,
      1500,
      3000,
      5000
    ].forEach(
      function (delay) {

        setTimeout(
          run,
          delay
        );
      }
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();
  }


  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        run,
        100
      );

      setTimeout(
        run,
        500
      );
    }
  );

})();